module.exports = __webpack_public_path__ + "img/RPrimusPilus64_ua.af8eba4b.webp";